import React from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import './Dashboard.css';

const PaymentStatusPage = () => {
	const [searchParams] = useSearchParams();
	const navigate = useNavigate();

	// 1. Get the status from the URL (?status=success)
	const status = searchParams.get('status');

	// 2. If for some reason there's no status, handle it so it doesn't crash
	if (!status) {
		return (
			<div style={{ textAlign: 'center', padding: '50px' }}>
				<h2>Invalid Request</h2>
				<button onClick={() => navigate('/')}>Go Back Home</button>
			</div>
		);
	}


	return (
		<div className="payment-status-container">
			<div className={`status-card animate-in ${status}`}>
				<span className="status-icon">
					{status === 'success' ? '✔' : '✖'}
				</span>
				<h1>{status === 'success' ? 'Payment Successful' : 'Payment Failed'}</h1>
				<p>
					{status === 'success'
						? 'Thank you! Your subscription is now active. You can now access all premium features.'
						: 'We could not process your payment. Please check your card details or try again later.'}
				</p>
				<button
					className={`status-btn ${status === 'failure' ? 'retry' : ''}`}
					onClick={() => navigate(status === 'success' ? '/dashboard' : '/subscription')}
				>
					{status === 'success' ? 'Go to Dashboard' : 'Try Again'}
				</button>
			</div>
		</div>
	);


};


export default PaymentStatusPage;
